import {ForkEffect, spawn} from 'redux-saga/effects';

import loginSaga, {requestLogin} from './sagas/loginSaga';
import logoutSaga, {requestLogout} from './sagas/logoutSaga';
import signupSaga, {requestSignup} from './sagas/signupSaga';
import authenticationSaga, {
  requestAuthentication,
} from './sagas/authenticationSaga';
import autoAuthenticationSaga, {
  requestAutoAuthentication,
} from './sagas/autoAuthenticationSaga';

function* userSaga(): Generator<ForkEffect<void>, void, unknown> {
  yield spawn(loginSaga);
  yield spawn(logoutSaga);
  yield spawn(signupSaga);
  yield spawn(authenticationSaga);
  yield spawn(autoAuthenticationSaga);
}

export {
  requestLogin,
  requestLogout,
  requestSignup,
  requestAuthentication,
  requestAutoAuthentication,
};

export default userSaga;
